import { render, staticRenderFns } from "./audioInfChat.vue?vue&type=template&id=127e2ef8&scoped=true"
import script from "./audioInfChat.vue?vue&type=script&lang=js"
export * from "./audioInfChat.vue?vue&type=script&lang=js"
import style0 from "./audioInfChat.vue?vue&type=style&index=0&id=127e2ef8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127e2ef8",
  null
  
)

export default component.exports